import {
  INTRUSION_PARTITION_EDIT_ROUTE,
  INTRUSION_PARTITION_VIEW_INFO_ROUTE,
  INTRUSION_PARTITION_VIEW_ROUTE,
  INTRUSION_ROUTE
} from '@/config/routes/intrusion';

export default [
  {
    path: INTRUSION_ROUTE.ROUTE_PATH,
    components: {
      default: () => import(/* webpackChunkName: "container-intrusion" */ './IntrusionContainer.vue')
    },
    meta: {
      privileges: INTRUSION_ROUTE.PRIVILEGES
    },
    children: [
      {
        path: '',
        name: INTRUSION_ROUTE.ROUTE_NAME,
        components: {
          default: () => import(/* webpackChunkName: "page-intrusion-list" */ './IntrusionListPage.vue')
        }
      },
      {
        path: INTRUSION_PARTITION_VIEW_ROUTE.ROUTE_PATH,
        meta: {
          privileges: INTRUSION_PARTITION_VIEW_ROUTE.PRIVILEGES,
          scopeSelectorDisabled: true
        },
        components: {
          default: () =>
            import(/* webpackChunkName: "page-intrusion-partition-view" */ './partition-view/IntrusionPartitionViewRoute.vue')
        },
        children: [
          {
            path: INTRUSION_PARTITION_VIEW_INFO_ROUTE.ROUTE_PATH,
            name: INTRUSION_PARTITION_VIEW_INFO_ROUTE.ROUTE_NAME,
            meta: {
              privileges: INTRUSION_PARTITION_VIEW_INFO_ROUTE.PRIVILEGES
            },
            components: {
              default: () =>
                import(/* webpackChunkName: "page-intrusion-partition-view" */ './partition-view/IntrusionPartitionViewPage.vue')
            }
          },
          {
            path: INTRUSION_PARTITION_EDIT_ROUTE.ROUTE_PATH,
            name: INTRUSION_PARTITION_EDIT_ROUTE.ROUTE_NAME,
            meta: {
              privileges: INTRUSION_PARTITION_EDIT_ROUTE.PRIVILEGES
            },
            components: {
              default: () =>
                import(/* webpackChunkName: "page-intrusion-partition-edit" */ './partition-view/IntrusionPartitionEditPage.vue')
            }
          }
        ]
      }
    ]
  }
];
